import { createReducer, on } from '@ngrx/store';
import { IVariableDosageResponse } from 'src/app/pages/orders/interfaces/product.interface';
import {
  clearVariableDosageByKey,
  loadVariableDosage,
  loadVariableDosageFailure,
  loadVariableDosageSuccess,
} from './variable-dosage.actions';

export interface VariableDosageState {
  cache: { [key: string]: IVariableDosageResponse };
  loading: { [key: string]: boolean };
  error: { [key: string]: any };
}

export const initialState: VariableDosageState = {
  cache: {},
  loading: {},
  error: {},
};

export const variableDosageReducer = createReducer(
  initialState,
  on(loadVariableDosage, (state, { key }) => ({
    ...state,
    loading: { ...state.loading, [key]: true },
    error: { ...state.error, [key]: null },
  })),
  on(loadVariableDosageSuccess, (state, { key, data }) => ({
    ...state,
    cache: { ...state.cache, [key]: data },
    loading: { ...state.loading, [key]: false },
    error: { ...state.error, [key]: null },
  })),
  on(loadVariableDosageFailure, (state, { key, error }) => ({
    ...state,
    loading: { ...state.loading, [key]: false },
    error: { ...state.error, [key]: error },
  })),
  on(clearVariableDosageByKey, (state, { key }) => {
    const { [key]: _, ...restCache } = state.cache;
    const { [key]: __, ...restLoading } = state.loading;
    const { [key]: ___, ...restError } = state.error;
    return {
      ...state,
      cache: restCache,
      loading: restLoading,
      error: restError,
    };
  }),
);
